'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-ionicons/~/react/react.js
// module id = 158
// module chunks = 0